(function () {
    window.$ = window.jQuery = require('jquery-slim');
    require("./bootstrap");
    require("./modernizr-webp")

    $(function () {
        $('[data-toggle="tooltip"]').tooltip()
    })
})();
